import { ArrowUpRight, Columns2, MessageSquare, Plus } from "lucide-react";

import type { GtmBrainDoc } from "../api/GtmApi";
import { listPillars } from "./pillars";

type Props = {
  docs: GtmBrainDoc[];
  onOpenPillar: (key: string) => void;
  onAddPillar: () => void;
  onBackToOverview: () => void;
};

export default function BrainPillarsPanel({
  docs,
  onOpenPillar,
  onAddPillar,
  onBackToOverview,
}: Props) {
  const pillars = listPillars(docs);

  return (
    <div className="flex h-full w-[22rem] shrink-0 flex-col border-r border-slate-200 bg-white">
      <div className="border-b border-slate-100 px-4 py-3 text-xs text-slate-500">
        <button
          type="button"
          className="hover:text-slate-800 hover:underline"
          onClick={onBackToOverview}
        >
          Brain
        </button>
        <span className="mx-1.5 text-slate-300">›</span>
        <span className="font-medium text-slate-800">Message pillars</span>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-5">
        <div className="mb-4 flex items-start justify-between gap-2">
          <div>
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50">
                <Columns2 className="h-4 w-4 text-blue-600" />
              </span>
              <h2 className="text-base font-semibold text-slate-900">Message pillars</h2>
            </div>
            <p className="text-sm text-slate-500">
              One pain, your answer to it, and the proof. One document per pillar.
            </p>
          </div>
          <button
            type="button"
            onClick={onAddPillar}
            className="inline-flex shrink-0 items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-[11px] font-medium text-slate-700 hover:bg-slate-50"
          >
            <Plus className="h-3.5 w-3.5" />
            Add pillar
          </button>
        </div>

        {pillars.length === 0 ? (
          <p className="rounded-lg border border-dashed border-slate-200 px-3 py-6 text-center text-sm text-slate-500">
            No pillars yet. Add one to start.
          </p>
        ) : (
          <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200">
            {pillars.map((p) => (
              <li key={p.key}>
                <button
                  type="button"
                  className="flex w-full items-center gap-3 px-3 py-3.5 text-left transition-colors hover:bg-slate-50"
                  onClick={() => onOpenPillar(p.key)}
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50">
                    <MessageSquare className="h-4 w-4 text-blue-600" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block line-clamp-2 text-sm font-medium text-slate-900">
                      {p.label}
                    </span>
                    <span className="mt-0.5 block text-xs text-slate-500">
                      {p.filled} of {p.total} sections filled
                    </span>
                  </span>
                  <ArrowUpRight className="h-4 w-4 shrink-0 text-slate-400" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
